import React from "react";
import NotInterestedIcon from "@material-ui/icons/NotInterested";
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";

const OrderHistoryPostsaleIcon = ({ order }) => {
  return (
    <>
      {order && !order.posSale ? (
        <NotInterestedIcon color="disabled" />
      ) : Boolean(order.posSale.send) ? (
        <PictureAsPdfIcon color="error" />
      ) : (
        <PictureAsPdfIcon color="disabled" />
      )}
    </>
  );
};

export default React.memo(OrderHistoryPostsaleIcon);
